import React, { useCallback, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "src/components/app/layout/Layout";
import InfinitePaginatedList from "src/components/common/Pagination/InfinitePaginatedList";
import { useAppDispatch, useAppSelector } from "src/redux/hooks";
import { getOrderHistoryRequest } from "src/redux/slices/orderHistorySlice";
import Loader from "src/components/common/Loader";
import Header from "src/components/app/layout/Header";
import { OrderHistoryItemData } from "src/types/orderHistory.types";
import OrderHistoryItem from "./OrderHistoryItem";

const OrderHistoryScreen: React.FC = () => {
  const params = useParams();
  const supportProgramKey = params["support-program-key"];
  const orderData = useAppSelector((state) => state.orderHistory.orderHistory);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [totalLabTest, setTotalLabTest] = useState<number>(0);
  //   const fetchOrderHistoryList = (
  //     page: number
  //   ): Promise<{ items: any[]; hasMore: boolean }> => {
  //     return new Promise((resolve, reject) => {
  //       dispatch(
  //         getOrderHistoryRequest({
  //           resolve,
  //           reject,
  //           payload: {
  //             page: String(page),
  //             showPaginatedResponse: true,
  //           },
  //         })
  //       );
  //     }).then((res: any) => {
  //       console.log("res", res);
  //       const items = res?.data?.lab_tests || [];
  //       const hasMore = items.length === (res?.data?.lab_tests_per_page || 15);
  //       return { items, hasMore };
  //     });
  //   };
  const fetchOrderHistoryList = useCallback(
    (page: number): Promise<{ items: any[]; hasMore: boolean }> => {
      return new Promise((resolve, reject) => {
        dispatch(
          getOrderHistoryRequest({
            resolve,
            reject,
            payload: {
              page: String(page),
              showPaginatedResponse: true,
            },
          })
        );
      }).then((res: any) => {
        console.log("res", res);
        const items = res?.data?.lab_tests || [];
        const hasMore = items.length === (res?.data?.lab_tests_per_page || 15);
        setTotalLabTest(res?.data?.lab_tests_total || 0);
        return { items, hasMore };
      });
    },
    [dispatch] // only changes if dispatch changes
  );

  const onPressItem = (item: OrderHistoryItemData) => {
    // console.log("item", item);
  };

  const onPressMenuButton = (item: OrderHistoryItemData) => {
    // console.log("item", item);
  };

  const onDownloadReportPress = (item: OrderHistoryItemData) => {
    // console.log("item", item);
  };

  return (
    <Layout supportProgramKey={supportProgramKey || ""}>
      <div>
        <Header
          title="Order History"
          titlePosition="center"
          onBackClick={() => {
            navigate(`/app/${supportProgramKey}/book-lab-test`);
          }}
        />
      </div>
      {/* Results Count */}
      <div className="bg-white py-3 px-4 border-b border-gray-200">
        {orderData?.data?.total_lab_tests &&
          orderData?.data?.total_lab_tests > 0 && (
            <p className="text-sm text-gray-600">
              Showing {orderData?.data?.lab_tests?.length} of{" "}
              {orderData?.data?.total_lab_tests} results
            </p>
          )}
      </div>
      <div
        id="appointment-scroll-container"
        ref={scrollContainerRef}
        className="h-[calc(100vh-57px-45px)] overflow-y-auto space-y-3 p-4"
      >
        <InfinitePaginatedList
          fetchData={fetchOrderHistoryList}
          // containerHeight="calc(100vh - 120px)"
          containerHeight="100%"
          scrollableTarget="appointment-scroll-container"
          renderItem={(order: OrderHistoryItemData, index: number) => (
            // <div key={index} className="bg-gray-50 p-4 rounded-lg shadow-sm">
            //   <div className="flex justify-between items-center mb-4">
            //     <h2 className="text-lg font-semibold text-black">
            //       {order?.name} - {order?.ref_order_id}
            //     </h2>
            //   </div>
            // </div>
            <div key={index} className="">
              <OrderHistoryItem
                item={order}
                onPressItem={onPressItem}
                onPressMenuButton={onPressMenuButton}
                onDownloadReportPress={onDownloadReportPress}
              />
            </div>
          )}
          emptyMessage={
            <div className="flex justify-center items-center h-full">
              <p className="text-gray-500">No orders found</p>
            </div>
          }
          loader={
            <div className="flex justify-center items-center py-4">
              {/* <Spinner /> */}
              <Loader />
            </div>
          }
        />
      </div>
    </Layout>
  );
};

export default OrderHistoryScreen;
